import api from "@wallet-manager/node-types/dist/src/access/APIEndpoints/index";
import EptLedger from "@wallet-manager/node-types/dist/src/access/APIEndpoints/WalletManager/EPtLedger";
import {
  EndPtMerchantPortal,
  EndPtSwap,
} from "@wallet-manager/node-types/dist/src/access/const/AccessAPIEndPoints";
import EPtWalletManagement from "@wallet-manager/node-types/dist/src/access/APIEndpoints/WalletManager/EPtWalletManagement";
import {
  Direction,
  MerchantChainConfigStatus,
  SmartAccountType,
  WalletSmartAccountType,
} from "@wallet-manager/node-types/dist/src/postgres/const";
import EnumWalletTypes from "@wallet-manager/node-types/dist/types/postgres/const/WalletType";
import WalletRiskLevelRescanStatus from "@wallet-manager/node-types/dist/types/postgres/const/WalletRiskLevelRescanStatus";

import { alerting } from "../reducer/alerterSlice";
import { OneAssetFace } from "../reducer/assetsSlice";
import { ChainsFace } from "../reducer/chainsSlice";
import { store } from "../reducer/store";
import axios from "./axiosInstance";
import {
  IFreezeRequestRes,
  IFrozenFundRes,
  IgetWithdrawRequestParams,
  ILedgerBalanceAlertConfigDetail,
  IlistResult,
  IoperationDetailsRes,
  Ipage,
  IsignerGetOperation,
} from "./types";
import { MultisigData } from "src/views/AssetManagement/MerchantOperation/components/MultisigCell/components/MultisigDialog/types";
import { SweepDestWallets } from "src/components/ContractSweep/RecipientAddressSingleSelection";
import { BatchContractSweepPreviewParams } from "src/views/AssetManagement/BatchContractSweep/contexts/FormContext";
import { BatchContractSweepSubmitParams } from "src/views/AssetManagement/BatchContractSweep/contexts/PreviewContext";
import { BatchApproveAllowanceSubmitParams } from "src/views/AssetManagement/BatchApproveAllowance/contexts/PreviewContext";
import { BatchApproveAllowancePreviewParams } from "src/views/AssetManagement/BatchApproveAllowance/contexts/FormContext";
import { SpenderAddress } from "src/components/SpenderAddress/hooks/useQuerySpenderAddress";
import { GetAllRes } from "src/views/Report/ContractSweepRecipientBalanceReport/components/ContractSweepRecipientGroupTab/types/GetAllRes";
import { IoperationTab } from "src/views/AssetManagement/MerchantOperation/types/IoperationTab";
import EnumCriteria from "@wallet-manager/node-types/dist/src/postgres/const/Criteria";

export type MerchantOperationApiPath =
  | "getAll"
  | "apiWithdraw"
  | "portalWithdraw"
  | "sweep"
  | "swap"
  | "contractSweep";

const TAB_API_PATH_MAPPING: Record<IoperationTab, MerchantOperationApiPath> = {
  all: "getAll",
  api_withdraw_tab: "apiWithdraw",
  sweep_tab: "sweep",
  portal_withdraw_tab: "portalWithdraw",
  swap_tab: "swap",
  contract_sweep: "contractSweep",
};

const {
  EPtReport,
  EPtCrossMerchantTransfer,
  EPtGeneral,
  EPtTools,
  EPtAssetManagement,
} = api;

//deprecated, import {IlistResult} instead
export interface listFace {
  rows: any[];
  count: number;
  withdraw_checking_time?: string;
  chain_type?: string;
  chain_id?: string;
}

export async function resendWithdrawRequest(
  input: {
    batch_id: number | string;
  },
  config?: any,
) {
  return await axios.post<any, listFace>(
    EPtAssetManagement.EndPtWithdrawRequestRecord.resend,
    input,
  );
}

export async function resendSwapRequest(
  input: {
    batch_id: number | string;
  },
  config?: any,
) {
  return await axios.post<any, listFace>(EndPtSwap.resend, input);
}
//get from_index, to_index, wallet_version
export async function getChainIndexDetails(params: any, config?: any) {
  const { chain_id, chain_type, wallet_type } = params;
  const input = {
    params: {
      chain_id: chain_id,
      chain_type: chain_type,
      wallet_type: wallet_type,
    },
    ...config,
  };

  return await axios.get<never, any>(
    `merchant_portal/merchant_chain_configs/get_chain_config_with_index_details`,
    input,
  );
}
export async function getGeneratedAddressList(
  params: {
    pageSize: number;
    page: number;
  },
  config?: any,
) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };
  return await axios.get<any, IlistResult<any>>(
    `merchant_portal/merchant_chain_configs/get_all_with_address_count`,
    input,
  );
}
export async function confirmFailureWithStuckingBatchid(
  batch_id: string | number,
  config?: any,
) {
  const input = { batch_id, ...config };
  return await axios.post<any, IlistResult<any>>(
    `/merchant_portal/cancel_stuck_batch`,
    input,
  );
}
export async function getPortalAuditLog(
  params: {
    pageSize: number;
    page: number;
  },
  config?: any,
) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };
  return await axios.get<any, IlistResult<any>>(
    `merchant_portal/audit_log/audit_log_jwt`,
    input,
  );
}
export async function getAssetList(
  params: {
    pageSize: number;
    page: number;
  },
  config?: any,
) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };
  return await axios.get<any, IlistResult<any>>(
    `merchant_portal/assets/management`,
    input,
  );
}
export async function getApiInLog(
  params: {
    pageSize: number;
    page: number;
  },
  config?: any,
) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };
  return await axios.get<any, IlistResult<any>>(
    `merchant_portal/audit_log/api_in`,
    input,
  );
}
export async function getApiOutLog(
  params: {
    pageSize: number;
    page: number;
  },
  config?: any,
) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };
  return await axios.get<any, IlistResult<any>>(
    `merchant_portal/audit_log/api_out`,
    input,
  );
}
export async function getAuditLogWithReqId(
  params: {
    pageSize: number;
    page: number;
  },
  config?: any,
) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };
  return await axios.get<any, IlistResult<any>>(
    `merchant_portal/audit_log/get_audit_log_with_req_id`,
    input,
  );
}

export async function getWalletManagement(
  params: any,
  config?: any,
): Promise<any> {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };

  const res = await axios.get<IlistResult<any>>(
    `merchant_portal/query/wallets`,
    input,
  );
  return res;
}
export async function getWalletVersions(
  params?: {
    chain_type: number;
    chain_id?: number;
    smart_account_type?: WalletSmartAccountType;
    status?: MerchantChainConfigStatus;
    wallet_types?: (string | number)[];
  },
  config?: any,
) {
  const input = {
    params,
    ...config,
  };

  const res = await axios.get<
    any,
    {
      id: string;
      merchant_id: string;
      chain_type: number;
      chain_id: string;
      wallet_type: number;
      wallet_version: number;
      status: number;
      created_date: string;
      last_modified_date: string;
    }[]
  >(EPtGeneral.EndPtQuery.merchantChainConfigs, input);
  return res;
}

export async function getLedgerBalance(
  params: any,
  config?: any,
): Promise<any> {
  const input = {
    params,
    ...config,
  };

  const res = await axios.get<IlistResult<any>>(
    `merchant_portal/query/ledger_balance`,
    input,
  );
  return res;
}

export async function getAddressBookProposals(
  params: any,
  config?: any,
): Promise<any> {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };

  const res = await axios.get<IlistResult<any>>(
    `merchant_portal/address_book_proposals`,
    input,
  );
  return res;
}
export async function createAddressBookProposals(params: any) {
  return await axios.post(
    `merchant_portal/address_book_proposals/register`,
    params,
  );
}
export async function editAddressBookProposals(params: any) {
  return await axios.post(
    `merchant_portal/address_book_proposals/update`,
    params,
  );
}

export async function approveAddressBookProposals(
  params: { otp: string; id: number },
  config?: any,
) {
  const input = { ...params, ...config };
  return await axios.post<never, any>(
    `/merchant_portal/address_book_proposals/approve`,
    input,
  );
}

export async function rejectAddressBookProposals(
  params: { otp: string; id: number },
  config?: any,
) {
  const input = { ...params, ...config };
  return await axios.post<never, any>(
    `/merchant_portal/address_book_proposals/reject`,
    input,
  );
}
export async function deleteAddressBookWallet(params: any) {
  return await axios.post(
    `/merchant_portal/address_book_proposals/delete`,
    params,
  );
}

export async function getWalletBalance(
  params: any,
  config?: any,
): Promise<any> {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };

  const res = await axios.get<IlistResult<any>>(
    `merchant_portal/wallet_balances`,
    input,
  );
  return res;
}

//this Api is used for batch_withdraw to get enable list and general assetList
export async function fetchAllAssets(status?: string) {
  const input = { params: { status: status } };
  const res = await axios.get<never, OneAssetFace[]>(
    `merchant_portal/query/assets`,
    input,
  );
  return res;
}

export async function fetchAllChains() {
  const res = await axios.get<never, ChainsFace[]>(
    `merchant_portal/query/chains`,
  );
  return res;
}

export async function batchSweepPreview(
  params: any,
  config?: any,
): Promise<any> {
  const input = { ...params, ...config };
  const { gather_address, ...rest } = input;
  const newInput = { ...rest, preview: true };
  const notNumber = Number.isNaN(Number(newInput?.decimals));
  if (notNumber) {
    store.dispatch(alerting("warning", "asset not supported"));
    return;
  }

  const res = await axios.post(`merchant_portal/batch_sweep`, newInput);
  return res;
}
export async function batchSweep(params: any, config?: any): Promise<any> {
  const input = { ...params, ...config };
  const { gather_address, ...rest } = input;
  const newInput = { ...rest, gether_address: gather_address };
  const notNumber = Number.isNaN(Number(newInput?.decimals));
  if (notNumber) {
    store.dispatch(alerting("warning", "asset not supported"));
    return;
  }

  const res = await axios.post(`merchant_portal/batch_collect`, newInput);
  return res;
}
export async function batchWithdraw(params: any, config?: any): Promise<any> {
  const input = { ...params, ...config };
  const notNumber = Number.isNaN(Number(input?.decimals));
  if (notNumber) {
    store.dispatch(alerting("warning", "asset not supported"));
    return;
  }
  const res = await axios.post(`merchant_portal/batch_withdraw`, input);
  return res;
}

export async function createWalletAddress(params: any) {
  return await axios.post(
    `merchant_portal/wallet_management/get_address`,
    params,
  );
}

export async function getSweepRequest(
  params: any,
  config?: any,
): Promise<IlistResult<any>> {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };
  return await axios.get("merchant_portal/sweep_requests", input);
}

export async function getWithdrawRequest(
  params: IgetWithdrawRequestParams & Ipage,
  config?: any,
) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };
  const link = "merchant_portal/withdraw_requests";
  return await axios.get<never, IgetWithdrawRequestRes>(link, input);
}

export async function getWalletDeploymentRequests(
  params: any & Ipage,
  config?: any,
) {
  const { pageSize, page, ...rest } = params;

  // remove all null or undefined or empty string params
  const payload = { ...rest };
  const cleanPayload = Object.fromEntries(
    Object.entries(payload).filter(([_, v]) => v != null && v !== ""),
  );

  const input = {
    params: { ...cleanPayload, limit: pageSize, offset: pageSize * page },
    ...config,
  };
  const link =
    "merchant_portal/wallet_management/deploy_multisign_wallet_request/get_all";
  return await axios.get<never, any>(link, input);
}

export async function getSwapRequestRecord(params: any & Ipage, config?: any) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };
  const link = EndPtSwap.swapRequests;
  return await axios.get<never, any>(link, input);
}
export async function getSwapRequestRecordExport(
  params: any & Ipage,
  config?: any,
) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };
  const link = EndPtSwap.swapRequestsExport;
  return await axios.get<never, any>(link, input);
}

export async function getSettingRequest(params?: any, config?: any) {
  const input = { ...params, ...config };
  return await axios.get<never, any>(
    "merchant_portal/query/merchant/setting",
    input,
  );
}

export async function updateWithdrawSettingRequest(params: any, config?: any) {
  const input = { ...params, ...config };
  return await axios.post(
    "merchant_portal/asset_management/update_withdraw_setting",
    input,
  );
}

type IgetWithdrawRequestRes = IlistResult<{
  id: string;
  merchant_id: string;
  batch_id: number;
  chain_type: number;
  chain_id: string;
  asset_name: string;
  total_amount: string;
  total_count: string;
  hot_wallet_address: string;
  client_data: string;
  created_date: string;
  last_modified_date: string;
  batch: {
    id: string;
    merchant_id: string;
    chain_type: number;
    chain_id: string;
    operation_type: number;
    total_operation: number;
    total_step: number;
    current_step: number;
    status: number;
    created_date: string;
    last_modified_date: string;
    created_by: string;
    creator_type: number;
  };
}>;
export async function getMerchantReport(
  params: any,
  config?: any,
): Promise<IlistResult<any>> {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };
  const link = "/merchant_portal/wallet_balance_snapshots/merchant_wallets";
  return await axios.get(link, input);
}
export async function getMerchantRangeReport(
  params: any,
  config?: any,
): Promise<IlistResult<any>> {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };
  const link =
    "/merchant_portal/wallet_balance_snapshots/merchant_wallets/by_mark_date";
  return await axios.get(link, input);
}
export async function getMerchantReportByWallet(
  params: any,
  config?: any,
): Promise<IlistResult<any>> {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };
  const link =
    "/merchant_portal/wallet_balance_snapshots/merchant_wallets/by_wallet_type";
  return await axios.get(link, input);
}
export async function getClientReport(
  params: any,
  config?: any,
): Promise<IlistResult<any>> {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };
  const link =
    "/merchant_portal/wallet_balance_snapshots/merchant_client_wallets";
  return await axios.get(link, input);
}

export async function getClientRangeReport(
  params: any,
  config?: any,
): Promise<IlistResult<any>> {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };
  const link =
    "merchant_portal/wallet_balance_snapshots/merchant_client_wallets/by_mark_date";
  return await axios.get(link, input);
}
export async function getClientReportByWallet(
  params: any,
  config?: any,
): Promise<IlistResult<any>> {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };
  const link =
    "/merchant_portal/wallet_balance_snapshots/merchant_client_wallets/by_wallet_type";
  return await axios.get(link, input);
}

export async function getDepositAndWithdrawalStatistics(
  params: any,
  config?: any,
): Promise<IlistResult<any>> {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };

  const link = EPtReport.EndPtDepositAndWithdrawalStatistics.getAll;
  return await axios.get(link, input);
}
export async function getDepositAndWithdrawalStatisticsExport(
  params: any,
  config?: any,
): Promise<IlistResult<any>> {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };

  const link = EPtReport.EndPtDepositAndWithdrawalStatistics.export;

  return await axios.get(link, input);
}

export async function getTransferTransactionsRecord(params: any, config?: any) {
  const { pageSize, page, startDate, endDate, ...rest } = params;
  const input = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
    },
    ...config,
  };
  return await axios.get(`merchant_portal/transfer_transactions`, input);
}

export const rescanRiskLevel = async (
  data: {
    chain_id: string | number;
    chain_type: string | number;
    block_hash: string;
    tx_hash: string;
    direction: Direction;
  },
  config?: any,
) => {
  const url = "/merchant_portal/report/all_transaction/rescan_risk_level";
  const payload = {
    ...data,
    ...config,
  };

  return axios.post(url, payload);
};

// TODO: endpoint not available yet — replace URL when backend is ready.
//
// Rescan risk level — request a fresh rescan from Merkle Science for a given
// wallet. The wallet is identified by its primary key (wallet_id). The
// row's `id` field IS the wallet_id, so callers pass it through unchanged.
export interface RescanWalletRiskLevelRequest {
  wallet_id: number;
}

// Response shape from the rescan query endpoint. Field names match the
// backend's snake_case wire format; the hook layer maps this into the
// camelCase RescanResult the dialog consumes.
//
// `error_reason` is `null` on success and a non-null error string on
// failure (e.g. provider unreachable). `merkle_science_response` is the
// raw payload we got back from the provider, typed below.
export interface MerkleScienceTag {
  tag_name_verbose?: string;
  tag_type_verbose?: string;
  tag_subtype_verbose?: string;
}

export interface MerkleScienceResponse {
  // Tags come back as a dictionary keyed by tag name (e.g. { owner: {...} }).
  tags?: Record<string, MerkleScienceTag>;
  detail?: string | null;
  identifier?: string;
  // Mirrors `response_risk_level` from the parent envelope — kept here so
  // callers can read either side without re-deriving.
  risk_level?: number;
}

export interface RescanWalletRiskLevelResponse {
  wallet_risk_level_rescan_id: number;
  merchant_id: number;
  chain_type: number;
  chain_id: number;
  wallet_address: string;
  current_risk_level: number;
  // Optional: when the provider has no data yet, this stays undefined.
  // The dialog treats undefined / -2 as the "No Data" outcome.
  response_risk_level?: number;
  status: number;
  created_by: string;
  applied_by: string;
  merkle_science_response?: MerkleScienceResponse | null;
  created_date: string;
  last_modified_date: string;
  // Non-null when the rescan failed (status indicates which error). The
  // ProviderResponseDialog renders this so a failed rescan isn't silent.
  error_reason?: string | null;
}

export const getRescanResult = async (
  data: RescanWalletRiskLevelRequest,
  config?: any,
): Promise<unknown | undefined> => {
  const url = EPtWalletManagement.EndPtWalletManagement.rescanWalletRiskLevel;
  // `config` is the third axios.post argument — the request config. Don't
  // spread it into the body, otherwise `isSkipErrorHandling` (a config flag
  // the axios interceptor reads) gets sent to the backend instead of being
  // honored client-side.
  return axios.post(url, data, config);
};

// Apply a previously-queried rescan result. The backend already has the
// wallet + level context (it was stored when the rescan was queried), so
// the request only needs the rescan record id and the action verb.
export interface ApplyWalletRiskLevelRequest {
  wallet_risk_level_rescan_id: number;
  action: number;
}

export interface ApplyWalletRiskLevelResponse {
  result: boolean;
}

export const applyRescanRiskLevel = async (
  data: ApplyWalletRiskLevelRequest,
  config?: any,
): Promise<ApplyWalletRiskLevelResponse | undefined> => {
  const url = EPtWalletManagement.EndPtWalletManagement.applyWalletRiskLevel;
  // See `getRescanResult` above — config is the third axios.post arg.
  return axios.post<ApplyWalletRiskLevelRequest, ApplyWalletRiskLevelResponse>(
    url,
    data,
    config,
  );
};

// Precondition check for the Rescan button. Returns the lock duration so
// the dialog can compute whether the wallet is currently in cooldown.
//
// `isSkipErrorHandling: true` keeps the global error toast silent if the
// backend is down — the dialog still opens at the confirm step with the
// fallback compile-time `RESCAN_LOCK_TIME_MS` constant.
export interface GetLockTimeResponse {
  lock_time_ms?: number;
}

export const getLockTime = async (
  config?: any,
): Promise<GetLockTimeResponse | undefined> => {
  const url = "/merchant_portal/wallet_management/rescan_lock_time";
  return axios.post(url, undefined, config);
};

// TODO: endpoint not ready — replace URL once backend is wired up.
//
// Risk-checking record list. Used by:
//   * the Risk Checking Record tab's data table (filter + pagination)
//   * the Rescan dialog's "last rescan" lookup (filter + `pageSize: 1`)
// Wire shape isn't final yet — the row shape is intentionally loose and
// will tighten once the backend response is locked down.
export interface GetRiskCheckingRecordsRequest {
  // Wallet coordinates. Required by the dialog's "last rescan" lookup
  // (which filters by a specific wallet); optional for the table query
  // when the user wants to see records across all wallets.
  chainType?: string;
  chainId?: string;
  walletAddress?: string;
  walletAddresses?: string[];
  displayNames?: string[];
  statuses?: WalletRiskLevelRescanStatus[];
  createdBy?: string;
  createdDateFrom?: string;
  createdDateTo?: string;
  // Pagination. Required at the API layer so we can map `pageSize`/`page`
  // → `limit`/`offset` on the wire without worrying about undefined math.
  page: number;
  pageSize: number;
}

export interface RiskCheckingRecord {
  // Loose shape — exact wire fields will land when the API is finalized.
  // Only the fields the dialog + table actually read are typed here; the
  // hook layer falls back to `?.` reads for anything not yet known.
  id?: string;
  merchant_id?: string;
  chain_type?: number;
  chain_id?: string;
  wallet_address?: string;
  wallet_id?: string;
  current_risk_level?: number;
  response_risk_level?: number | null;
  // Maps to the WalletRiskLevelRescanStatus enum — backend returns the
  // numeric value; the hook layer (and the OutcomeCell renderer) translate
  // it to the matching enum name.
  status?: WalletRiskLevelRescanStatus;
  created_by?: string;
  applied_by?: string;
  merkle_science_response?: MerkleScienceResponse | null;
  created_date?: string;
  last_modified_date?: string;
  error_reason?: string | null;
  // Nested wallet record — some fields (display_name, wallet_name) live
  // here rather than on the top-level record.
  wallet?: {
    wallet_version?: number;
    status?: number;
    wallet_name?: string;
    display_name?: string;
    chain_type?: number;
    chain_id?: string;
    smart_account_type?: number | null;
  };
}

export interface GetRiskCheckingRecordsResponse {
  rows: RiskCheckingRecord[];
  count: number;
  // Server-side Merkle Science query timeout, in **seconds** as a string
  // (matches the backend's wire format). We use this as the lock duration
  // for the rescan dialog — call sites must multiply by 1000 to get ms.
  // Optional because older backend versions may not return it; call sites
  // fall back to the compile-time `RESCAN_LOCK_TIME_MS` constant.
  merkle_sci_api_timeout_sec?: string;
}

export const getRiskCheckingRecords = async (
  data: GetRiskCheckingRecordsRequest,
  config?: any,
): Promise<GetRiskCheckingRecordsResponse | undefined> => {
  const { page, pageSize, ...rest } = data;
  const url =
    "/merchant_portal/wallet_management/risk_level_records/get_all";
  // Match the project's pagination convention: callers use `page`/`pageSize`,
  // the wire carries `limit`/`offset` so the backend can compute the window
  // directly from offset without multiplying back. Array fields like
  // `statuses` and `walletAddresses` are serialized as repeated query
  // params by axios's default paramsSerializer (e.g. `?statuses=1&statuses=2`).
  return axios.get<
    Omit<GetRiskCheckingRecordsRequest, "page" | "pageSize"> & {
      limit: number;
      offset: number;
    },
    GetRiskCheckingRecordsResponse
  >(
    url,
    {
      params: { ...rest, limit: pageSize, offset: pageSize * page },
      ...config,
    },
  );
};

// Export the risk-checking records list. Same request shape as the
// get-all endpoint — the backend filters by the same fields.
//
// The backend returns `{ error, result, requestId }` where `result`
// is a flat array of rows (no `count` / pagination metadata — export is
// a single stream). With the interceptor's default behaviour the response
// unwraps to `data.result` which is the array itself.
export const exportRiskCheckingRecords = async (
  data: GetRiskCheckingRecordsRequest,
  config?: any,
): Promise<RiskCheckingRecord[] | undefined> => {
  const { page, pageSize, ...rest } = data;
  const url =
    "/merchant_portal/wallet_management/risk_level_records/export";
  // Match the same pagination convention as `getRiskCheckingRecords` —
  // `limit`/`offset` on the wire, `page`/`pageSize` in the request type.
  return axios.get<
    Omit<GetRiskCheckingRecordsRequest, "page" | "pageSize"> & {
      limit: number;
      offset: number;
    },
    RiskCheckingRecord[]
  >(
    url,
    {
      params: { ...rest, limit: pageSize, offset: pageSize * page },
      ...config,
    },
  );
};

export async function setDefaultMerchantWallet(params: any, config?: any) {
  const input = { ...params, ...config };
  return await axios.post(
    `merchant_portal/wallet_management/set_default_wallet`,
    input,
  );
}

export async function getWalletOperations(params: any, config?: any) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
    },
    ...config,
  };

  return await axios.get(`merchant_portal/wallet_operations`, input);
}
export async function getStuckTokenHistory(params: any, config?: any) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
    },
    ...config,
  };

  return await axios.get<any, IlistResult<any>>(
    `/merchant_portal/stuck_batch_request/get_all_groups`,
    input,
  );
}

export async function getOperationTransaction(params: any, config?: any) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
    },
    ...config,
  };
  return await axios.get(
    `merchant_portal/wallet_operation_transactions`,
    input,
  );
}
export async function getNonceToolNonceTab(params: any, config?: any) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
    },
    ...config,
  };
  return await axios.get(
    `merchant_portal/wallet_operation_batches/get_all_with_nonce_and_from_address`,
    input,
  );
}
export async function getMerchantClientBalance(params: any, config?: any) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
    },
    ...config,
  };
  return await axios.get(EptLedger.EndPtMerchantLedgerBalance.getAll, input);
}
export async function getMerchantClientBalanceExport(
  params: any,
  config?: any,
) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
    },
    ...config,
  };
  return await axios.get(EptLedger.EndPtMerchantLedgerBalance.export, input);
}
export async function getLiquidityProviderClientBalance(
  params: any,
  config?: any,
) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
    },
    ...config,
  };
  return await axios.get(
    EptLedger.EndPtLiquidityProviderLedgerBalance.getAll,
    input,
  );
}
export async function getLiquidityProviderClientBalanceExport(
  params: any,
  config?: any,
) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
    },
    ...config,
  };
  return await axios.get(
    EptLedger.EndPtLiquidityProviderLedgerBalance.export,
    input,
  );
}
export async function getClientManagement(params: any, config?: any) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
    },
    ...config,
  };
  return await axios.get(`merchant_portal/ledger_client/get_all`, input);
}
export async function getClientManagementExport(params: any, config?: any) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
    },
    ...config,
  };
  return await axios.get(`merchant_portal/ledger_client/export`, input);
}
export async function postClientManagementAddClient(params: any, config?: any) {
  const input = {
    ...params,
    ...config,
  };
  return await axios.post(`merchant_portal/ledger_client/create_client`, input);
}
export async function postClientManagementEditClient(
  params: any,
  config?: any,
) {
  const input = {
    ...params,
    ...config,
  };
  return await axios.post(`merchant_portal/ledger_client/update_client`, input);
}

export async function getLedgerTransactionRecord(params: any, config?: any) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
    },
    ...config,
  };
  return await axios.get(`merchant_portal/ledger_transaction/get_all`, input);
}
export async function getLedgerTransactionRecordExport(
  params: any,
  config?: any,
) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
    },
    ...config,
  };
  return await axios.get(`merchant_portal/ledger_transaction/export`, input);
}

export async function postLedgerTransactionRecordResend(
  params: {
    merchant_order_id: string;
    trans_id: string;
    include_original_merchant_order_id: boolean;
    direction: string;
  },
  config?: any,
) {
  const input = {
    ...params,
    ...config,
  };
  return await axios.post(
    `merchant_portal/ledger_rebroadcast_transaction_event`,
    input,
  );
}

export async function getWalletManagerDepositRecord(params: any, config?: any) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
    },
    ...config,
  };
  return await axios.get(
    `merchant_portal/ledger_wallet_manager_deposit/get_all`,
    input,
  );
}
export async function getWalletManagerDepositRecordExport(
  params: any,
  config?: any,
) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
    },
    ...config,
  };
  return await axios.get(
    `merchant_portal/ledger_wallet_manager_deposit/export`,
    input,
  );
}
export async function getLedgerWithdrawRequest(params: any, config?: any) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
    },
    ...config,
  };
  return await axios.get(
    `merchant_portal/ledger_withdraw_request/get_all`,
    input,
  );
}
export async function getLedgerWithdrawRequestApprovalDetail(
  params: any,
  config?: any,
) {
  const input = {
    params,
    ...config,
  };
  return await axios.get(
    `merchant_portal/ledger_withdraw_request/approval_details`,
    input,
  );
}
export async function getLedgerWalletManagerDepositRecordApprovalDetail(
  params: any,
  config?: any,
) {
  const input = {
    params,
    ...config,
  };
  return await axios.get(
    `merchant_portal/ledger_wallet_manager_deposit/approval_details`,
    input,
  );
}
export async function getLedgerWalletManagerDepositRecordSwitchDetail(
  params: any,
  config?: any,
) {
  const input = {
    params,
    ...config,
  };
  return await axios.get(
    `merchant_portal/ledger_wallet_manager_deposit/switch_approval_details`,
    input,
  );
}
export async function getLedgerWalletManagerDepositRecordToDoCount(
  config?: any,
) {
  const input = {
    ...config,
  };
  return await axios.get(
    `merchant_portal/ledger_wallet_manager_deposit/get_to_do_count`,
    input,
  );
}
export async function getLedgerTransferRequestApprovalDetail(
  params: any,
  config?: any,
) {
  const input = {
    params,
    ...config,
  };
  return await axios.get(
    `merchant_portal/ledger_transfer_request/approval_details`,
    input,
  );
}
export async function getLedgerWithdrawRequestExport(
  params: any,
  config?: any,
) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
    },
    ...config,
  };
  return await axios.get(
    `merchant_portal/ledger_withdraw_request/export`,
    input,
  );
}
export async function getLedgerTransferRequest(params: any, config?: any) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
    },
    ...config,
  };
  return await axios.get(
    `merchant_portal/ledger_transfer_request/get_all`,
    input,
  );
}
export async function getLedgerTransferRequestExport(
  params: any,
  config?: any,
) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
    },
    ...config,
  };
  return await axios.get(
    `merchant_portal/ledger_transfer_request/export`,
    input,
  );
}
export async function postLedgerTransferRequestCreate(
  params: any,
  config?: any,
) {
  const input = {
    ...params,
    ...config,
  };
  return await axios.post(
    `merchant_portal/ledger_transfer_request/create_transfer_request`,
    input,
  );
}
export async function getCrossMerchantTransferRequest(
  params: any,
  config?: any,
) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
    },
    ...config,
  };
  return await axios.get(
    EPtCrossMerchantTransfer.EPtCrossMerchantTransferRequest.getAll,
    input,
  );
}
export async function getCrossMerchantTransferRequestExport(
  params: any,
  config?: any,
) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
    },
    ...config,
  };
  return await axios.get(
    EPtCrossMerchantTransfer.EPtCrossMerchantTransferRequest.export,
    input,
  );
}
export async function getCrossMerchantTransferRequestApprovalDetail(
  params: any,
  config?: any,
) {
  const input = {
    params,
    ...config,
  };
  return await axios.get(
    EPtCrossMerchantTransfer.EPtCrossMerchantTransferApproval.approvalDetails,
    input,
  );
}
export async function postCrossMerchantTransferRequestApprove(
  params: any,
  config?: any,
) {
  const input = {
    ...params,
    ...config,
  };
  return await axios.post(
    EPtCrossMerchantTransfer.EPtCrossMerchantTransferApproval
      .approveTransferRequest,
    input,
  );
}
export async function postCrossMerchantTransferRequestReject(
  params: any,
  config?: any,
) {
  const input = {
    ...params,
    ...config,
  };
  return await axios.post(
    EPtCrossMerchantTransfer.EPtCrossMerchantTransferApproval
      .rejectTransferRequest,
    input,
  );
}
export async function queryMerchant() {
  // const { pageSize, page, ...rest } = params;

  // const input = {
  //   params: { limit: pageSize, offset: pageSize * page, ...rest },
  //   ...config,
  // };

  return await axios.get<any, { id: string; name: string }[] | undefined>(
    EPtGeneral.EndPtQuery.merchants,
  );
}
export async function queryLiquidityProviders() {
  // const { pageSize, page, ...rest } = params;

  // const input = {
  //   params: { limit: pageSize, offset: pageSize * page, ...rest },
  //   ...config,
  // };

  return await axios.get<
    any,
    | {
        merchant_id: number;
        liquidity_provider: string;
        remarks: string;
        created_date: string;
        last_modified_date: string;
      }[]
    | undefined
  >(EPtGeneral.EndPtQuery.liquidityProviders);
}

export async function postLedgerWithdrawRequestCreate(
  params: any,
  config?: any,
) {
  const input = {
    ...params,
    ...config,
  };
  return await axios.post(
    `merchant_portal/ledger_withdraw_request/create_withdraw_request`,
    input,
  );
}
export async function postLedgerTransferRequestApprove(
  params: any,
  config?: any,
) {
  const input = {
    ...params,
    ...config,
  };
  return await axios.post(
    `merchant_portal/ledger_transfer_request/approve_transfer_request`,
    input,
  );
}
export async function postLedgerTransferRequestReject(
  params: any,
  config?: any,
) {
  const input = {
    ...params,
    ...config,
  };
  return await axios.post(
    `merchant_portal/ledger_transfer_request/reject_transfer_request`,
    input,
  );
}
export async function postLedgerWithdrawRequestApprove(
  params: any,
  config?: any,
) {
  const input = {
    ...params,
    ...config,
  };
  return await axios.post(
    `merchant_portal/ledger_withdraw_request/approve_withdraw_request`,
    input,
  );
}
export async function postLedgerWithdrawRequestReject(
  params: any,
  config?: any,
) {
  const input = {
    ...params,
    ...config,
  };
  return await axios.post(
    `merchant_portal/ledger_withdraw_request/reject_withdraw_request`,
    input,
  );
}
export async function postLedgerWalletManagerDepositRecordSwitch(
  params: any,
  config?: any,
) {
  const input = {
    ...params,
    ...config,
  };
  return await axios.post(
    `merchant_portal/ledger_wallet_manager_deposit/accept_deposit`,
    input,
  );
}
export async function postLedgerWalletManagerDepositRecordApprove(
  params: any,
  config?: any,
) {
  const input = {
    ...params,
    ...config,
  };
  return await axios.post(
    `merchant_portal/ledger_wallet_manager_deposit/approve_deposit_request`,
    input,
  );
}
export async function postLedgerWalletManagerDepositRecordReject(
  params: any,
  config?: any,
) {
  const input = {
    ...params,
    ...config,
  };
  return await axios.post(
    `merchant_portal/ledger_wallet_manager_deposit/reject_deposit_request`,
    input,
  );
}

export async function getAdjustBalanceTable(
  params: any,
  config?: any,
): Promise<IlistResult<any>> {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };
  const link = "/merchant_portal/balance_adjustment_proposals";
  return await axios.get(link, input);
}

export async function checkCurrentBalanceApi(
  params: any,
  config?: any,
): Promise<any> {
  const { ...rest } = params;
  const input = {
    params: { ...rest },
    ...config,
  };
  const link = "/merchant_portal/query/wallet_balance";
  return await axios.get(link, input);
}

export async function adjustBalance(params: any, config?: any): Promise<any> {
  const input = { ...params, ...config };
  return await axios.post(
    `merchant_portal/balance_adjustment_proposals/create`,
    input,
  );
}

export async function approveAdjustBalance(
  params: { id: string; otp: string },
  config?: any,
) {
  const input = { ...params, ...config };
  return await axios.post(
    `merchant_portal/balance_adjustment_proposals/approve`,
    input,
  );
}

export async function rejectAdjustBalance(
  params: { id: string; otp: string },
  config?: any,
) {
  const input = { ...params, ...config };
  return await axios.post(
    `merchant_portal/balance_adjustment_proposals/reject`,
    input,
  );
}

export async function getMessages(params: any, config?: any) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };
  return await axios.get(`merchant_portal/messages`, input);
}

export async function walletOperationBatchsCount(
  params: {
    pageSize: number;
    page: number;
    chain_type?: number | string;
    chain_id?: number | string;
    asset_names?: string[];
  },
  config?: any,
) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };
  return await axios.get<any, IlistResult<any>>(
    `merchant_portal/wallet_operation_batches/count_by_tx_status`,
    input,
  );
}

export async function rebroadcastTransactions(
  batch_id: string | number,
  config?: any,
) {
  const input = { batch_id, ...config };
  return await axios.post(`merchant_portal/rebroadcast_transactions`, input);
}

export async function resetMessages(
  id: string | number,
  config?: any,
): Promise<any> {
  const input = { id: [id], ...config };
  return await axios.post(`merchant_portal/messages/reset_attempt`, input);
}

export const rescanBlocks = async (params: any, config?: any): Promise<any> => {
  const input = { ...params, ...config };
  const res = await axios.post<any>(`/merchant_portal/rescan_blocks`, input);
  return res;
};
export const rescanTrx = async (params: any, config?: any): Promise<any> => {
  const input = { ...params, ...config };
  const res = await axios.post<any>(
    `merchant_portal/rescan/transaction_rescan`,
    input,
  );
  return res;
};
export const rescanUserOperationHash = async (
  params: any,
  config?: any,
): Promise<any> => {
  const input = { ...params, ...config };
  const res = await axios.post<any>(
    EPtTools.EndPtRescan.smartTransactionRescan,
    input,
  );
  return res;
};
export const rescanOpTrxRecordWithUserOpHash = async (
  params: {
    chain_id: number | string;
    chain_type: number | string;
    user_op_hashes: string[];
  },
  config?: any,
): Promise<any> => {
  const input = { ...params, ...config };
  const res = await axios.post<any>(
    EPtAssetManagement.EndPtOperationTransactionRecords.smartTransactionRescan,
    input,
  );
  return res;
};
export const rebroadcastOpTrxRecordWithUserOpHash = async (
  params: {
    batch_id: string;
    user_op_hash: string;
  },
  config?: any,
): Promise<any> => {
  const input = { ...params, ...config };
  const res = await axios.post<any>(
    EndPtMerchantPortal.rebroadcastSmartTransaction,
    input,
  );
  return res;
};
export const yubiRegister = async (
  params: { otp: string },
  config?: any,
): Promise<any> => {
  const input = { ...params, ...config };
  const res = await axios.post<any>(
    `/merchant_portal/portal_users/register`,
    input,
  );
  return res;
};
export const yubiKeyBind = async (
  params: { otp: string; new_otp: string },
  config?: any,
): Promise<any> => {
  const input = { ...params, ...config };
  const res = await axios.post<any>(
    `/merchant_portal/portal_users/bind_yubi_key`,
    input,
  );
  return res;
};

//in use, but will be refactored
export const yubiKeyReBind = async (
  params: { new_otp: string },
  config?: any,
): Promise<any> => {
  const input = { ...params, ...config };
  const res = await axios.post<any>(
    `/merchant_portal/portal_users/bind_yubi_key`,
    input,
  );
  return res;
};
export const assetEdit = async (
  params: {
    chain_type?: any;
    chain_id?: any;
    asset_name: string;
    asset_config_status: string;
    asset_config_deposit_push: boolean;
    otp: string;
  },
  config?: any,
): Promise<any> => {
  const input = { ...params, ...config };
  const res = await axios.post<any>(`/merchant_portal/assets/edit`, input);
  return res;
};

export async function walletCheckPoint(
  params: {
    pageSize: number;
    page: number;
    id?: string;
    chain_id?: number | string;
    chain_type?: number | string;
    assetNames?: any[];
    mark_time_from?: string;
    mark_time_to?: string;
    created_date_from?: string;
    created_date_to?: string;
    is_certified?: number;
    wallet_address?: string;
    block_number?: string;
  },
  config?: any,
): Promise<any> {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };
  return await axios.get(`merchant_portal/wallet_check_points`, input);
}

export async function rescanTransactions(
  params: {
    chain_id: number | string;
    chain_type: number | string;
    tx_hashes: string[];
  },
  config?: any,
): Promise<any> {
  const input = { ...params, ...config };
  return await axios.post<never, { result: boolean }>(
    `merchant_portal/operation_transaction_records/transaction_rescan`,
    input,
  );
}
export async function rebroadcastTxn(
  params: {
    batch_id: number | string;
    tx_hash: string;
  },
  config?: any,
): Promise<any> {
  const input = { ...params, ...config };
  return await axios.post<never, { result: boolean }>(
    `merchant_portal/rebroadcast_txn`,
    input,
  );
}

export async function updateWalletDisplayName(params: any, config?: any) {
  const input = { ...params, ...config };
  return await axios.post(
    `merchant_portal/wallet_management/update_wallet_display_name`,
    input,
  );
}

export async function getBtcUtxo(params: any, config?: any) {
  const { pageSize, page, ...rest } = params;
  const input = {
    ...rest,
    limit: pageSize,
    offset: params.pageSize * params.page,
    ...config,
  };
  return await axios.post<never, any>(
    `merchant_portal/utxo_tool/get_btc_utxo`,
    input,
  );
}
export async function getAdaUtxo(params: any, config?: any) {
  const { pageSize, page, ...rest } = params;
  const input = {
    ...rest,
    limit: pageSize,
    offset: params.pageSize * params.page,
    ...config,
  };
  return await axios.post<never, any>(
    `merchant_portal/utxo_tool/get_ada_utxo`,
    input,
  );
}
export async function syncBtcUtxo(params: any, config?: any) {
  const input = {
    ...params,
    ...config,
  };
  return await axios.post<never, any>(
    `merchant_portal/utxo_tool/sync_btc_utxo`,
    input,
  );
}
export async function syncAdaUtxo(params: any, config?: any) {
  const input = {
    ...params,
    ...config,
  };
  return await axios.post<never, any>(
    `merchant_portal/utxo_tool/sync_ada_utxo`,
    input,
  );
}

export async function deleteBtcUtxo(params: any, config?: any) {
  const input = {
    ...params,
    ...config,
  };
  return await axios.post<never, any>(
    `merchant_portal/utxo_tool/delete_btc_utxo`,
    input,
  );
}
export async function deleteAdaUtxo(params: any, config?: any) {
  const input = {
    ...params,
    ...config,
  };
  return await axios.post<never, any>(
    `merchant_portal/utxo_tool/delete_ada_utxo`,
    input,
  );
}

export async function getOperationAll(params: any, config?: any) {
  const { pageSize, page, batchIdArr, ...rest } = params;
  const input = {
    params: {
      ...rest,
      batch_id: batchIdArr,
      limit: pageSize,
      offset: pageSize * page,
    },
    ...config,
  };
  return await axios.get<never, IlistResult<IsignerGetOperation>>(
    `merchant_portal/merchant_operation/get_all/operations`,
    input,
  );
}
export async function getOperationApi(params: any, config?: any) {
  const { pageSize, page, batchIdArr, ...rest } = params;
  const input = {
    params: {
      ...rest,
      batch_id: batchIdArr,
      limit: pageSize,
      offset: pageSize * page,
    },
    ...config,
  };
  return await axios.get<never, IlistResult<IsignerGetOperation>>(
    `merchant_portal/merchant_operation/api_withdraw/operations`,
    input,
  );
}
export async function getOperationPortal(params: any, config?: any) {
  const { pageSize, page, batchIdArr, ...rest } = params;
  const input = {
    params: {
      ...rest,
      batch_id: batchIdArr,
      limit: pageSize,
      offset: pageSize * page,
    },
    ...config,
  };
  return await axios.get<never, IlistResult<IsignerGetOperation>>(
    `merchant_portal/merchant_operation/portal_withdraw/operations`,
    input,
  );
}
export async function getOperationSweep(params: any, config?: any) {
  const { pageSize, page, batchIdArr, ...rest } = params;
  const input = {
    params: {
      ...rest,
      batch_id: batchIdArr,
      limit: pageSize,
      offset: pageSize * page,
    },
    ...config,
  };
  return await axios.get<never, IlistResult<IsignerGetOperation>>(
    `merchant_portal/merchant_operation/sweep/operations`,
    input,
  );
}
export async function getOperationDetailsAll(params: any, config?: any) {
  const { pageSize, page, batchId, ...rest } = params;
  const input = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
      batchId,
    },
    ...config,
  };
  return await axios.get<never, IlistResult<IoperationDetailsRes>>(
    `merchant_portal/merchant_operation/get_all/operation_details`,
    input,
  );
}
export function getOperationDetails(tab: IoperationTab) {
  return async (params: any, config?: any) => {
    const { pageSize, page, batchId, ...rest } = params;
    const input = {
      params: {
        ...rest,
        limit: pageSize,
        offset: pageSize * page,
        batchId,
      },
      ...config,
    };
    return await axios.get<never, IlistResult<IoperationDetailsRes>>(
      EPtAssetManagement.EndPtMerchantOperation[TAB_API_PATH_MAPPING[tab]]
        .operationDetails,
      input,
    );
  };
}

export function downloadTransactionDetails(tab: IoperationTab) {
  return async (batch_id: string, config?: any) => {
    const input = {
      params: { batch_id: batch_id },
      ...config,
    };
    return await axios.get(
      EPtAssetManagement.EndPtMerchantOperation[TAB_API_PATH_MAPPING[tab]]
        .downloadTransactions,
      input,
    );
  };
}

export function getOperationDetailStat(tab: IoperationTab) {
  return async (params: any, config?: any) => {
    const { batch_id, merchant_id } = params;
    const input = {
      params: {
        batch_id: batch_id,
        merchant_id: merchant_id,
      },
      ...config,
    };
    return await axios.get<never, any>(
      EPtAssetManagement.EndPtMerchantOperation[TAB_API_PATH_MAPPING[tab]]
        .operationDetailsStat,
      input,
    );
  };
}

export function getOpManualReason(tab: IoperationTab) {
  return async (params: any, config?: any) => {
    const { batch_id, merchant_id } = params;
    const input = {
      params: {
        batch_id: batch_id,
        merchant_id: merchant_id,
      },
      ...config,
    };
    return await axios.get<any>(
      EPtAssetManagement.EndPtMerchantOperation[TAB_API_PATH_MAPPING[tab]]
        .manualApprovalReasons,
      input,
    );
  };
}

export function reEstimateFee(tab: IoperationTab) {
  return async (params: { batchId: string }, config?: any) => {
    const payload = { ...params, ...config };
    return await axios.post<never, IestimateDetail>(
      EPtAssetManagement.EndPtMerchantOperation[TAB_API_PATH_MAPPING[tab]]
        .estimateFee,
      payload,
    );
  };
}

export function getOperation(tab: IoperationTab) {
  return async (params: any, config?: any) => {
    const { pageSize, page, batchIdArr, ...rest } = params;
    const input = {
      params: {
        ...rest,
        batch_id: batchIdArr,
        limit: pageSize,
        offset: pageSize * page,
      },
      ...config,
    };
    return await axios.get<never, IlistResult<IsignerGetOperation>>(
      EPtAssetManagement.EndPtMerchantOperation[TAB_API_PATH_MAPPING[tab]]
        .operations,
      input,
    );
  };
}

export function uploadTransactionDetails(tab: IoperationTab) {
  return async (batch_id: string, text: any, config?: any) => {
    const input = {
      batch_id: batch_id,
      data: text,
      ...config,
    };
    return await axios.post(
      EPtAssetManagement.EndPtMerchantOperation[TAB_API_PATH_MAPPING[tab]]
        .uploadTransactions,
      input,
    );
  };
}

export async function getOperationDetailsApi(params: any, config?: any) {
  const { pageSize, page, batchId, ...rest } = params;
  const input = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
      batchId,
    },
    ...config,
  };
  return await axios.get<never, IlistResult<IoperationDetailsRes>>(
    `merchant_portal/merchant_operation/api_withdraw/operation_details`,
    input,
  );
}
export async function getOperationDetailsPortal(params: any, config?: any) {
  const { pageSize, page, batchId, ...rest } = params;
  const input = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
      batchId,
    },
    ...config,
  };
  return await axios.get<never, IlistResult<IoperationDetailsRes>>(
    `merchant_portal/merchant_operation/portal_withdraw/operation_details`,
    input,
  );
}
export async function getOperationDetailsSweep(params: any, config?: any) {
  const { pageSize, page, batchId, ...rest } = params;
  const input = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
      batchId,
    },
    ...config,
  };
  return await axios.get<never, IlistResult<IoperationDetailsRes>>(
    `merchant_portal/merchant_operation/sweep/operation_details`,
    input,
  );
}

export async function getOperationDetailStatAll(params: any, config?: any) {
  const { batch_id, merchant_id } = params;
  const input = {
    params: {
      batch_id: batch_id,
      merchant_id: merchant_id,
    },
    ...config,
  };
  return await axios.get<never, any>(
    `merchant_portal/merchant_operation/get_all/operation_details_stat`,
    input,
  );
}
export async function getOperationDetailStatApi(params: any, config?: any) {
  const { batch_id, merchant_id } = params;
  const input = {
    params: {
      batch_id: batch_id,
      merchant_id: merchant_id,
    },
    ...config,
  };
  return await axios.get<never, any>(
    `merchant_portal/merchant_operation/api_withdraw/operation_details_stat`,
    input,
  );
}
export async function getOperationDetailStatPortal(params: any, config?: any) {
  const { batch_id, merchant_id } = params;
  const input = {
    params: {
      batch_id: batch_id,
      merchant_id: merchant_id,
    },
    ...config,
  };
  return await axios.get<never, any>(
    `merchant_portal/merchant_operation/portal_withdraw/operation_details_stat`,
    input,
  );
}
export async function getOperationDetailStatSweep(params: any, config?: any) {
  const { batch_id, merchant_id } = params;
  const input = {
    params: {
      batch_id: batch_id,
      merchant_id: merchant_id,
    },
    ...config,
  };
  return await axios.get<never, any>(
    `merchant_portal/merchant_operation/sweep/operation_details_stat`,
    input,
  );
}

export async function downloadTransactionDetailsAll(
  batch_id: string,
  config?: any,
) {
  const input = {
    params: { batch_id: batch_id },
    ...config,
  };
  return await axios.get(
    `merchant_portal/merchant_operation/get_all/download_transactions`,
    input,
  );
}
export async function downloadTransactionDetailsApi(
  batch_id: string,
  config?: any,
) {
  const input = {
    params: { batch_id: batch_id },
    ...config,
  };
  return await axios.get(
    `merchant_portal/merchant_operation/api_withdraw/download_transactions`,
    input,
  );
}
export async function downloadTransactionDetailsPortal(
  batch_id: string,
  config?: any,
) {
  const input = {
    params: { batch_id: batch_id },
    ...config,
  };
  return await axios.get(
    `merchant_portal/merchant_operation/portal_withdraw/download_transactions`,
    input,
  );
}
export async function downloadTransactionDetailsSweep(
  batch_id: string,
  config?: any,
) {
  const input = {
    params: { batch_id: batch_id },
    ...config,
  };
  return await axios.get(
    `merchant_portal/merchant_operation/sweep/download_transactions`,
    input,
  );
}

export async function getOpManualReasonAll(params: any, config?: any) {
  const { batch_id, merchant_id } = params;
  const input = {
    params: {
      batch_id: batch_id,
      merchant_id: merchant_id,
    },
    ...config,
  };
  return await axios.get<any>(
    `merchant_portal/merchant_operation/get_all/manual_approval_reasons`,
    input,
  );
}
export async function getOpManualReasonApi(params: any, config?: any) {
  const { batch_id, merchant_id } = params;
  const input = {
    params: {
      batch_id: batch_id,
      merchant_id: merchant_id,
    },
    ...config,
  };
  return await axios.get<any>(
    `merchant_portal/merchant_operation/api_withdraw/manual_approval_reasons`,
    input,
  );
}
export async function getOpManualReasonPortal(params: any, config?: any) {
  const { batch_id, merchant_id } = params;
  const input = {
    params: {
      batch_id: batch_id,
      merchant_id: merchant_id,
    },
    ...config,
  };
  return await axios.get<any>(
    `merchant_portal/merchant_operation/portal_withdraw/manual_approval_reasons`,
    input,
  );
}
export async function getOpManualReasonSweep(params: any, config?: any) {
  const { batch_id, merchant_id } = params;
  const input = {
    params: {
      batch_id: batch_id,
      merchant_id: merchant_id,
    },
    ...config,
  };
  return await axios.get<any>(
    `merchant_portal/merchant_operation/sweep/manual_approval_reasons`,
    input,
  );
}
export interface IestimateDetail {
  batch_id: string;
  miner_fee_asset_name: string;
  estimated_miner_fee: string;
  estimated_miner_fee_decimals: string;
  last_estimated_miner_fee_date: string;
}
export async function reEstimateFeeGetAll(
  params: { batchId: string },
  config?: any,
) {
  const payload = { ...params, ...config };
  return await axios.post<never, IestimateDetail>(
    `merchant_portal/merchant_operation/get_all/estimate_fee`,
    payload,
  );
}
export async function reEstimateFeeApiWithdraw(
  params: { batchId: string },
  config?: any,
) {
  const payload = { ...params, ...config };
  return await axios.post<never, IestimateDetail>(
    `merchant_portal/merchant_operation/api_withdraw/estimate_fee`,
    payload,
  );
}
export async function reEstimateFeeWithdrawPortal(
  params: { batchId: string },
  config?: any,
) {
  const payload = { ...params, ...config };
  return await axios.post<never, IestimateDetail>(
    `merchant_portal/merchant_operation/portal_withdraw/estimate_fee`,
    payload,
  );
}
export async function reEstimateFeeSweep(
  params: { batchId: string },
  config?: any,
) {
  const payload = { ...params, ...config };
  return await axios.post<never, IestimateDetail>(
    `merchant_portal/merchant_operation/sweep/estimate_fee`,
    payload,
  );
}

export async function getMerchantOperationMultisigByTab(
  params: { batchId: string; tabPath: MerchantOperationApiPath },
  config?: any,
) {
  const { batchId, tabPath } = params;
  const input = {
    params: {
      batch_id: batchId,
    },
    ...config,
  };
  return await axios.get<any, MultisigData>(
    EPtAssetManagement.EndPtMerchantOperation[tabPath].multisignStatus,
    input,
  );
}

export async function postRetryPrepareMultisig(
  params: { batchId: string },
  config?: any,
) {
  const input = {
    ...params,
    ...config,
  };

  return await axios.post("/signer/multisign_prepare_retry", input);
}

interface ResubmitTransactionParams {
  (
    data: {
      batch_id: string;
    },
    config?: any,
  ): Promise<any>;
}

export const sweepRequestRecordResubmitBatch: ResubmitTransactionParams = (
  data,
) => {
  const url =
    "merchant_portal/asset_management/sweep_request_record/resubmit_batch";
  const payload = {
    ...data,
  };
  return axios.post(url, payload);
};

export const withdrawRequestRecordResubmitBatch: ResubmitTransactionParams = (
  data,
) => {
  const url =
    "/merchant_portal/asset_management/withdraw_request_record/resubmit_batch";
  const payload = {
    ...data,
  };
  return axios.post(url, payload);
};

// TODO: WM-3850 resubmit api
export const walletDeploymentRequestsResubmitBatch: ResubmitTransactionParams =
  (data) => {
    const url =
      "/merchant_portal/wallet_management/deploy_multisign_wallet_request/resubmit_batch";
    const payload = {
      ...data,
    };
    return axios.post(url, payload);
  };
export const swapRequestRecordResubmitBatch: ResubmitTransactionParams = (
  data,
) => {
  const payload = {
    ...data,
  };
  return axios.post(EndPtSwap.resubmitBatch, payload);
};

interface ICreateWalletDeploymentRequestPayload {
  wallet_type?: EnumWalletTypes;
  chain_type: number | undefined;
  chain_id: number | undefined;
  wallet_address: string;
  multisign_wallet_name: string;
  operation_smart_account_type: SmartAccountType;
  contract_version: string;
}
export const createWalletDeploymentRequest = (
  data: ICreateWalletDeploymentRequestPayload,
) => {
  const url =
    "/merchant_portal/wallet_management/deploy_multisign_wallet_request/create";
  const payload = {
    ...data,
    wallet_type: EnumWalletTypes.HotWallet,
  };
  return axios.post(url, payload);
};

export async function getLedgerFreezeRequest(params: any, config?: any) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };
  return await axios.get<never, IFreezeRequestRes>(
    `merchant_portal/ledger_freeze_requests/get_all`,
    input,
  );
}
export async function getLedgerFreezeRequestExport(params: any, config?: any) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };
  return await axios.get<never, IFreezeRequestRes>(
    `merchant_portal/ledger_freeze_requests/export`,
    input,
  );
}
export async function getLedgerFrozenFund(params: any, config?: any) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };
  return await axios.get<never, IFrozenFundRes>(
    `merchant_portal/ledger_frozen_funds/get_all`,
    input,
  );
}
export async function getLedgerFrozenFundExport(params: any, config?: any) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };
  return await axios.get<never, IFrozenFundRes>(
    `merchant_portal/ledger_frozen_funds/export`,
    input,
  );
}
export async function getCrossMerchantTransferRecord(
  params: any,
  config?: any,
) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };
  return await axios.get(
    `merchant_portal/cross_merchant_transfer/get_all`,
    input,
  );
}
export async function getCrossMerchantTransferRecordExport(
  params: any,
  config?: any,
) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };
  return await axios.get(
    `merchant_portal/cross_merchant_transfer/export`,
    input,
  );
}
export async function fetchAllLiquidityProviders() {
  return await axios.get<
    never,
    IlistResult<
      {
        id: string;
        merchant_id: string;
        liquidity_provider: string;
        remarks: string;
        created_date: string;
        last_modified_date: string;
      }[]
    >
  >(`/merchant_portal/liquidity_provider/get_all?limit=100&offset=0`);
}

export async function getCrossMerchantTransferPathMerchantTab(
  params: any,
  config?: any,
) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };
  return await axios.get<never, any>(
    EPtCrossMerchantTransfer.EPtCrossMerchantTransferPath
      .getAllWithExchangeRate,
    input,
  );
}

export async function getCrossMerchantTransferPathMerchantTabExport(
  params: any,
  config?: any,
) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };
  return await axios.get<never, any>(
    EPtCrossMerchantTransfer.EPtCrossMerchantTransferPath
      .exportWithExchangeRate,
    input,
  );
}

export async function getCrossMerchantTransferPath(params: any, config?: any) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };
  return await axios.get<never, any>(
    EPtCrossMerchantTransfer.EPtCrossMerchantTransferPath
      .getAllWithLiquidityProvider,
    input,
  );
}

export async function getCrossMerchantTransferPathExport(
  params: any,
  config?: any,
) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };
  return await axios.get<never, any>(
    EPtCrossMerchantTransfer.EPtCrossMerchantTransferPath
      .exportWithLiquidityProvider,
    input,
  );
}

interface ICreateCrossMerchantTransferRequestPayload {
  from_merchant_id: number;
  from_chain_type: string;
  from_chain_id: number;
  from_asset_name: string;
  to_merchant_id: number;
  to_chain_type: string;
  to_chain_id: number;
  to_asset_name: string;
  liquidity_provider: string;
  amount?: string;
  decimals: number;
  nonce: number;
  from_client_id: string;
  to_client_id: string;
  to_amount?: string;
  to_decimals?: number;
  exchange_rate?: string;
  exchange_rate_ref?: string;
}

export async function createCrossMerchantTransferRequest(
  params: ICreateCrossMerchantTransferRequestPayload,
  config?: any,
) {
  return await axios.post<never, any>(
    EPtCrossMerchantTransfer.EPtCrossMerchantTransferRequest.create,
    { ...params },
  );
}

export interface IUpdateExchangeRateRequestPayload {
  liquidityProviderMerchantId: number;
  pathId: number;
  exchangeRate: string;
  externalRef: string;
}

export async function updateCrossMerchantTransferExchangeRate(
  params: IUpdateExchangeRateRequestPayload,
  config?: any,
) {
  return await axios.post<never, any>(
    EPtCrossMerchantTransfer.EPtCrossMerchantTransferExchangeRate.update,
    params,
    config,
  );
}

export async function getBalance(
  data: {
    assetName: string;
    chainType: number;
    chainId: string;
    clientId: string;
  },
  config?: any,
) {
  return await axios.get<
    never,
    {
      id: string;
      merchant_id: string;
      client_id: string;
      chain_type: number;
      chain_id: string;
      asset_name: string;
      balance: string;
      frozen_balance: string;
      created_date: string;
      last_modified_date: string;
      credit: string;
      last_ledger_transaction_id: string;
    }
  >("/merchant_portal/ledger_balance/get_one", {
    params: { ...data },
    ...config,
  });
}

export async function getLiquidityBalance(
  data: { pathId: string },
  config?: any,
) {
  return await axios.get<never, any>(
    EPtCrossMerchantTransfer.EPtCrossMerchantTransferPath.getLiquidityBalance,
    {
      params: { ...data },
      ...config,
    },
  );
}

export async function getSpenderAddress({
  params,
  config,
}: {
  params: {
    chainType: number;
    chainId: string;
    assetName: string;
    status: number;
  };
  config?: any;
}) {
  const input = { params, ...config };

  return await axios.get<never, SpenderAddress[]>(
    EPtGeneral.EndPtQuery.spenderAddresses,
    input,
  );
}

export async function postBatchApproveAllowancePreview(
  params: BatchApproveAllowancePreviewParams,
  config?: any,
) {
  return await axios.post<never, any>(
    EPtAssetManagement.EndPtWalletApproveAllowance.preview,
    params,
    config,
  );
}
export async function postBatchApproveAllowanceSubmit(
  params: BatchApproveAllowanceSubmitParams,
  config?: any,
) {
  return await axios.post<never, any>(
    EPtAssetManagement.EndPtWalletApproveAllowance.submitBatch,
    params,
    config,
  );
}

export async function getBatchAutoSweepDestWallets(
  params: {
    chainType: string | number;
    chainId: string;
    assetName: string;
    status: number;
    riskType: string;
  },
  config?: any,
) {
  const input = { params, ...config };

  return await axios.get<never, SweepDestWallets[]>(
    EPtGeneral.EndPtQuery.autoSweepAssetDestWallet,
    input,
  );
}

export async function postBatchContractSweepPreview(
  params: BatchContractSweepPreviewParams,
  config?: any,
) {
  return await axios.post<never, any>(
    EPtAssetManagement.EndPtBatchContractSweep.preview,
    params,
    config,
  );
}

export async function postBatchContractSweepSubmit(
  params: BatchContractSweepSubmitParams,
  config?: any,
) {
  return await axios.post<never, any>(
    EPtAssetManagement.EndPtBatchContractSweep.create,
    params,
    config,
  );
}

export async function getAllContractSweepRecipientGroup(
  params: any,
  config?: any,
) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };

  return await axios.get<never, GetAllRes>(
    EPtReport.EndPtAutoSweepDestBalanceReport.byGroup.getAll,
    input,
  );
}
export async function getExportContractSweepRecipientGroup(
  params: any,
  config?: any,
) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };

  return await axios.get<never, GetAllRes>(
    EPtReport.EndPtAutoSweepDestBalanceReport.byGroup.export,
    input,
  );
}
export async function getAllContractSweepRecipient(params: any, config?: any) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };

  return await axios.get<never, GetAllRes>(
    EPtReport.EndPtAutoSweepDestBalanceReport.byAddress.getAll,
    input,
  );
}
export async function getExportContractSweepRecipient(
  params: any,
  config?: any,
) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };

  return await axios.get<never, GetAllRes>(
    EPtReport.EndPtAutoSweepDestBalanceReport.byAddress.export,
    input,
  );
}

export async function getAllWalletBalanceMonitor(params: any, config?: any) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };

  return await axios.get<never, GetAllRes>(
    EPtWalletManagement.EndPtWalletManagement.getAllWalletBalanceAlertConfigs,
    input,
  );
}
export async function addWalletBalanceMonitor(
  params: {
    assetName: string;
    walletAddress: string;
    chainType: number;
    chainId: string;
    details: { criteria: EnumCriteria; thresholdValue: string }[];
  },
  config?: any,
) {
  return await axios.post<
    never,
    {
      error: {
        code: number;
        message: string;
        data: unknown | null;
        inner_error: unknown | null;
      } | null;
      result: true | null;
      requestId: string;
    }
  >(
    EPtWalletManagement.EndPtWalletManagement
      .createWalletBalanceAlertConfigDetails,
    params,
    { ...config, isSkipErrorHandling: true },
  );
}
export async function editWalletBalanceMonitor(
  params: {
    assetName: string;
    walletAddress: string;
    chainType: number;
    chainId: string;
    details: { criteria: EnumCriteria; thresholdValue: string }[];
  },
  config?: any,
) {
  return await axios.post<never, GetAllRes>(
    EPtWalletManagement.EndPtWalletManagement
      .updateWalletBalanceAlertConfigDetails,
    params,
    config,
  );
}
export async function deleteWalletBalanceMonitor(
  params: {
    assetName: string;
    walletAddress: string;
    chainType: number;
    chainId: string;
  },
  config?: any,
) {
  return await axios.post<never, GetAllRes>(
    EPtWalletManagement.EndPtWalletManagement
      .deleteWalletBalanceAlertConfigDetails,
    params,
    config,
  );
}
export async function getAllLedgerBalanceMonitor(params: any, config?: any) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: { ...rest, limit: pageSize, offset: pageSize * page },
    ...config,
  };

  return await axios.get<never, GetAllRes>(
    EptLedger.EndPtMerchantLedgerBalanceAlertConfigs
      .getAllLedgerBalanceAlertConfigs,
    input,
  );
}
export async function addLedgerBalanceMonitor(
  params: {
    assetName: string;
    clientId: string;
    chainType: number;
    chainId: string;
    details: ILedgerBalanceAlertConfigDetail[];
  },
  config?: any,
) {
  return await axios.post<
    never,
    {
      error: {
        code: number;
        message: string;
        data: unknown | null;
        inner_error: unknown | null;
      } | null;
      result: true | null;
      requestId: string;
    }
  >(
    EptLedger.EndPtMerchantLedgerBalanceAlertConfigs
      .createLedgerBalanceAlertConfigDetails,
    params,
    { ...config, isSkipErrorHandling: true },
  );
}
export async function editLedgerBalanceMonitor(
  params: {
    assetName: string;
    clientId: string;
    chainType: number;
    chainId: string;
    details: ILedgerBalanceAlertConfigDetail[];
  },
  config?: any,
) {
  return await axios.post<never, GetAllRes>(
    EptLedger.EndPtMerchantLedgerBalanceAlertConfigs
      .updateLedgerBalanceAlertConfigDetails,
    params,
    config,
  );
}
export async function deleteLedgerBalanceMonitor(
  params: {
    assetName: string;
    clientId: string;
    chainType: number;
    chainId: string;
  },
  config?: any,
) {
  return await axios.post<never, GetAllRes>(
    EptLedger.EndPtMerchantLedgerBalanceAlertConfigs
      .deleteLedgerBalanceAlertConfigDetails,
    params,
    config,
  );
}
